import { SuperAdminDashboardPage } from "../../operator/console/super-admin-dashboard";

export default function ConsoleSuperAdminDashboard() {
  return <SuperAdminDashboardPage />;
}
